export default __webpack_public_path__ + "static/media/success.b79c6460.svg";